module.exports = __webpack_public_path__ + "static/media/logo-agsus.62b4b5ee.png";